webpackJsonp([50739212244294],{

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Link;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '../css/link.css';
	
	function Link(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      to = _ref.to;
	
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { className: ['link'].concat(className || []).join(' '), to: to },
	    children
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Tags;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Link = __webpack_require__(53);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '../css/tags.css';
	
	function Tags(_ref) {
	  var pathContext = _ref.pathContext;
	  var posts = pathContext.posts,
	      post = pathContext.post,
	      tag = pathContext.tag;
	
	  if (tag) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        post.length,
	        ' \u043F\u043E\u0441\u0442',
	        post.length === 1 ? '' : 'а',
	        ' \u0441 \u0442\u0435\u0433\u043E\u043C ',
	        tag
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        post.map(function (_ref2) {
	          var id = _ref2.id,
	              frontmatter = _ref2.frontmatter,
	              excerpt = _ref2.excerpt;
	
	          return _react2.default.createElement(
	            'article',
	            { key: id, className: 'post-preview' },
	            _react2.default.createElement(
	              'header',
	              { className: 'post-preview__header' },
	              _react2.default.createElement(
	                _Link2.default,
	                { to: frontmatter.path },
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  frontmatter.title
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'section',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                excerpt
	              )
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        _Link2.default,
	        { to: '/tags' },
	        '\u0412\u0441\u0435 \u0442\u0435\u0433\u0438'
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '\u0422\u0435\u0433\u0438'
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'tags' },
	      Object.keys(posts).map(function (tagName) {
	        var tags = posts[tagName];
	        return _react2.default.createElement(
	          'li',
	          { key: tagName },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/tags/' + tagName },
	            tagName
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      _Link2.default,
	      { to: '/' },
	      '\u0412\u0441\u0435 \u043F\u043E\u0441\u0442\u044B'
	    )
	  );
	}
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tags-js-3a8c6884db681b577417.js